const RENDITION_SPREAD = 'http://www.idpf.org/vocab/rendition/#spread';

/**
 * Returns the manifest with `rendition:spread` under the `spread` key.
 *
 * The manifest carries the property under its URI, and Readium's fixed-layout
 * frame pool only reads `metadata.spread`. A manifest that already has
 * `spread` keeps its own value.
 *
 * @param {Object} manifest - The RWPM manifest JSON
 * @returns {Object} The manifest to deserialize
 */
export function withRenditionSpread(manifest) {
    const spread = manifest.metadata?.[RENDITION_SPREAD];
    if (!spread) return manifest;

    return { ...manifest, metadata: { spread, ...manifest.metadata } };
}
